export default "__VITE_ASSET__thO1PecU__"